// src/main-wrapper/MainContainer.tsx

import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import { BusinessProvider } from '../context/BusinessContext';

const MainLayout: React.FC = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = React.useState(false);

  return (
    <BusinessProvider>
      <div className="flex h-[100dvh] overflow-hidden bg-gray-50">
        <Sidebar onCollapseChange={setIsSidebarCollapsed} />
        <div
          className={`
            transition-all duration-300
            flex flex-col relative w-full overflow-hidden
            ${isSidebarCollapsed ? "ml-[65px]" : "ml-[200px]"}
          `}
          style={{
            width: isSidebarCollapsed
              ? "calc(100dvw - 65px)"
              : "calc(100dvw - 200px)"
          }}
        >
          <Outlet />
        </div>
      </div>
    </BusinessProvider>
  );
};

export default MainLayout;
